import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { LyricsPageProps } from "./LyricsPage";
const LyricsPage = lazy(() => import("./LyricsPage").then(module => ({ default: module.LyricsPage })));
export function mountLyricsPage(slot: HTMLElement, props: LyricsPageProps) {
  setStudioView("stage", `lyrics:${props.project.id}`, <LyricsPage key={props.project.id} {...props} />);
}
